import { render, staticRenderFns } from "./singUpLook.vue?vue&type=template&id=4b7cb586&scoped=true&"
import script from "./singUpLook.vue?vue&type=script&lang=js&"
export * from "./singUpLook.vue?vue&type=script&lang=js&"
import style0 from "./singUpLook.vue?vue&type=style&index=0&id=4b7cb586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7cb586",
  null
  
)

export default component.exports